import { render, staticRenderFns } from "./EventSharing.vue?vue&type=template&id=67169b4a&scoped=true"
import script from "./EventSharing.vue?vue&type=script&lang=ts"
export * from "./EventSharing.vue?vue&type=script&lang=ts"
import style0 from "./EventSharing.vue?vue&type=style&index=0&id=67169b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67169b4a",
  null
  
)

export default component.exports